import * as ActionTypes from './ActionTypes';

export const Adventures = (state = {
        isLoading: true,
        errMess: null,
        adventures: []
    }, action) => {
    switch(action.type) {
        case ActionTypes.ADD_ADVENTURES:
            return {...state, isLoading: false, errMess: null, adventures: action.payload};

        case ActionTypes.ADD_ADVENTURE:
            return {...state, isLoading: false, errMess: null, adventures: state.adventures.concat(action.payload)};

        case ActionTypes.ADVENTURES_LOADING:
            return {...state, isLoading: true, errMess: null, adventures: []};

        case ActionTypes.ADVENTURES_FAILED:
            return {...state, isLoading: false, errMess: action.payload, adventures: []};

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/adventures.js